import React, { useState } from "react";

import { FormButton } from "components";
import { FormikTextInput } from "components/UI/Inputs/FormikInputs";

import { Form, Formik } from "formik";
import * as yup from "yup";

import { useRecoilValue, useSetRecoilState } from "recoil";
import {
    rowSelected,
    snackbarData,
    userCredentials,
} from "recoilState/GlobalState";

import { FORM_ERROR_MESSAGES } from "consts/errorMessages";

import styles from "styles/pages/ModalActions.module.scss";
import { handleResponse } from "services/Local-services";
import { migraPasoUpd } from "services/services-mia/migra";

export default function StatusModal({ updateList, paso, closeModal }) {
    const setSelected = useSetRecoilState(rowSelected);
    const setSnackbarInfo = useSetRecoilState(snackbarData);
    const credentials = useRecoilValue(userCredentials);

    const [inRequest, setInRequest] = useState(false);

    const targetStatus = paso.migraPasoStatus === "A" ? "B" : "A";
    const buttonLabel = targetStatus === "B" ? "Dar de Baja" : "Dar de Alta";
    const successMsg =
        targetStatus === "B"
            ? "Paso dado de baja exitosamente"
            : "Paso dado de alta exitosamente";

    const handleSubmit = async () => {
        setInRequest(true);

        const response = await migraPasoUpd(
            {
                migraPasoId: paso.id,
                migraPasoCod: paso.migraPasoCod,
                migraPasoNombre: paso.migraPasoNombre,
                gateLugarId: paso.gateLugarId,
                migraTipoDePasoId: paso.migraTipoDePasoId,
                migraPasoStatus: targetStatus,
                migraPasoVersion: paso.migraPasoVersion,
            },
            credentials
        );

        handleResponse(response, successMsg, {
            setSnackbarInfo,
            setIsOpen: closeModal,
            setSelected,
            updateList,
        });

        setInRequest(false);
    };

    return (
        <Formik
            initialValues={{
                migraPasoNombre: paso.migraPasoNombre,
            }}
            validationSchema={yup.object({
                migraPasoNombre: yup
                    .string(FORM_ERROR_MESSAGES.text)
                    .required(FORM_ERROR_MESSAGES.required),
            })}
            onSubmit={(values, { setSubmitting }) => {
                try {
                    handleSubmit();
                } catch (e) {
                    setSnackbarInfo({
                        message: e.errmsg,
                        severity: "error",
                        open: true,
                    });
                } finally {
                    setSubmitting(false);
                }
            }}
        >
            <Form className={styles.inputs} noValidate>
                <div className={styles["column-sm"]}>
                    <FormikTextInput
                        fullWidth={true}
                        name="migraPasoNombre"
                        labelText="Paso"
                        disabled
                    />
                    <FormButton
                        inRequest={inRequest}
                        newFormData={{ button: buttonLabel }}
                        onCloseModal={closeModal}
                    />
                </div>
            </Form>
        </Formik>
    );
}
